import { Row, Col, Container, Input, Label, Button, FormGroup, Form, Alert } from 'reactstrap'
import React, { Component } from 'react'
import axios from 'axios'

import '../styles/createUsers.css'

function checkThing (thing, value) {
  if (thing === 'email') {
    let regex = /\S+@\S+\.\S+/
    return regex.test(value)
  }
  if (thing === 'pseudo') {
    let regex = /[a-zA-Z][a-zA-Z0-9]{5,31}/
    return regex.test(value)
  }
  if (thing === 'password') {
    let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm
    return regex.test(value)
  }
}

function msgLog(x) {
  if (x !== undefined) {
    if (x === 409) {return 'Cet email est deja utilisé.'}
    else if (x === 503) {return 'Un erreur est survenue'}
    else if (x === 200) {return 'Votre compte a été crée avec succès'}
    else if (x === 400) {return 'Veuillez remplir tous les champs.'}
    else {return 'Erreur'}
  }
}

class CreateUser extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: {
        email: '',
        pseudo: '',
        password: '',
        roles: 'ADMINISTRATOR'
      },
      email: null,
      pseudo: null,
      password: null,
      confirmPass: '',
      test: null,
      response: null,
      resMsg: null,
      resCode: null
    }
    this.handleChange = this.handleChange.bind(this)
    this.postUser = this.postUser.bind(this)
    this.postConfirm = this.postConfirm.bind(this)
  }

  // Fill in new USER Object
  handleChange(e) {
    this.setState({
      ...this.state,
      user: {
        ...this.state.user,
        [e.target.name]: e.target.value
      },
      [e.target.name]: checkThing(e.target.name, e.target.value)
    })
  }

  postUser () {
    if (this.state.user.password === this.state.confirmPass) {
      axios({
        method: 'post',
        url: `${process.env.REACT_APP_API_URL}/user/admin`,
        data: this.state.user,
        headers: {
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(res => {
        this.setState({
          ...this.state,
          resMsg: msgLog(res.request.status),
          resCode: res.request.status
        })
      }).catch((res, err) => {
        this.setState({
          ...this.state,
          resMsg: msgLog(res.request.status),
          resCode: res.request.status
        })
      })
    } else {
      this.setState({
        ...this.state,
        resMsg: 'Erreur de confirmation de mot de passe.'
      })
    }
  }

  postConfirm (e) {
    this.setState({
      ...this.state,
      confirmPass: e.target.value,
      test: e.target.value === this.state.user.password ? true : false
    })
  }

  render () {
    return (
      <div>
        <Container className={'mT-5'}>
          <Row className={'border-bottom-grey'}>
            <h1 className={'txtcenter w100p pB-2'}>Créer un Administrateur</h1>
          </Row>
          <Row>
            <Col>
              <h3 className={'txtcenter pT-5'}>Régles de profil:</h3>
              <div className={''}>
                <ul className={'hCenter w59p'}>
                  <Row className={'pB-2 w100p'}>
                    <Col sm={11} className={''}>
                      <li className={this.state.pseudo === true ? 'color-green' : (this.state.pseudo === false ? 'color-red' : 'color-black' )}>Un pseudo valide:
                      <ul>
                        <li>Le premier caractère est une lettre</li>
                        <li>Le pseudo ne contient que des chiffres ou des lettres</li>
                        <li>Il fait au minimum 6 caractères</li>
                      </ul>
                      </li>
                    </Col>
                    <Col className={''} sm={1}>
                      <i className={this.state.pseudo === true ? 'green thumbs up icon' : (this.state.pseudo === false ? 'thumbs down red icon' : 'minus icon')} />
                    </Col>
                  </Row>
                  <Row className={'pB-2 w100p'}>
                    <Col sm={11} className={''}>
                      <li className={this.state.email === true ? 'color-green' : (this.state.email === false ? 'color-red' : 'color-black' ) }>Un email valide:</li>
                    </Col>
                    <Col className={''} sm={1}>
                      <i className={this.state.email === true ? 'green thumbs up icon' : (this.state.email === false ? 'thumbs down red icon' : 'minus icon')} />
                    </Col>
                  </Row>
                  <Row className={'pB-2 w100p'}>
                    <Col sm={11} className={''}>
                      <li className={this.state.password === true ? 'color-green' : (this.state.password === false ? 'color-red' : 'color-black' ) }>Un mot de passe valide:
                      <ul>
                        <li>Contient au moins une majuscule, une minuscule et un chiffre</li>
                        <li>Peut contenir un caractère special</li>
                        <li>Il fait au minimum 8 caractères</li>
                      </ul>
                      </li>
                    </Col>
                    <Col className={''} sm={1}>
                      <i className={this.state.password === true ? 'green thumbs up icon' : (this.state.password === false ? 'thumbs down red icon' : 'minus icon')} />
                    </Col>
                  </Row>
                  <Row className={'pB-2 w100p'}>
                    <Col sm={11} className={''}>
                      <li className={this.state.test === true ? 'color-green' : (this.state.test === false ? 'color-red' : 'color-black')}>Mot de passe confirmé:</li>
                    </Col>
                    <Col className={''} sm={1}>
                      <i className={this.state.test === true ? 'green thumbs up icon' : (this.state.test === false ? 'thumbs down red icon' : 'minus icon')} />
                    </Col>
                  </Row>
                </ul>
              </div>
            </Col>
          </Row>
          <Row className={''}>
            <Col>
              <div className={'w54p hCenter pT-2'}>
                {this.state.resMsg === null ? null : <Alert className={'txtcenter'} color={this.state.resCode === 200 ? 'success' : 'danger'}><i className={this.state.resCode === 200 ? 'checked icon' : 'exclamation circle icon'} />{this.state.resMsg}</Alert>}
              </div>
            </Col>
          </Row>
          <hr className={'mL-10 mR-10'} />
          <Row className={''}>
            <Form className={'w100p pT-2 pL-10 pR-10'}>
              <FormGroup row>
                <Label for='exampleEmail' sm={3}>Pseudo <span className={'color-red'}>*</span></Label>
                <Col sm={9}>
                  <Input type='text' name='pseudo' placeholder='Pseudo' onChange={this.handleChange.bind(this)} />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for='exampleEmail' sm={3}>Email <span className={'color-red'}>*</span></Label>
                <Col sm={9}>
                  <Input type='email' name='email' placeholder='Email'  onChange={this.handleChange.bind(this)} />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for='examplePassword' sm={3}>Mot de passe <span className={'color-red'}>*</span></Label>
                <Col sm={9}>
                  <Input type='password' name='password' placeholder='Mot de passe'  onChange={this.handleChange.bind(this)} />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for='examplePassword' sm={3}>Confirmer votre mot de passe</Label>
                <Col sm={9}>
                  <Input type='password' name='passwordConf' placeholder='Mot de passe' onChange={this.postConfirm.bind(this)} />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col sm={{ size: 4, offset: 8 }} >
                  <Button block color='success' onClick={this.postUser.bind(this)}>Créer</Button>
                </Col>
              </FormGroup>
            </Form>
          </Row>
        </Container>
      </div>
    )
  }
}

export default CreateUser



// WEBPACK FOOTER //
// ./src/components/CreateUser.js